import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';


import {Injectable} from '@angular/core';
import {AnomalyEntity, AnomalyResult, QARService, SystemEntity} from '../services/qar.service';

@Component({
	selector: 'app-page-anomalies',
	templateUrl: './anomalies.html',
	providers: [QARService]
})
export class AnomaliesPageComponent implements OnInit {

	constructor(public apiQAR: QARService) {
		this.self = this;
	}

	public self;

	public anomalies = {
		loading: false,
		selected: new AnomalyResult(),
		SystemBatchRowIdSelected: 0,
		chunker: (new Chunker([])),
		withDuplicates: {},
		chunkedData: [],
		descriptions: AnomalyEntity.TypeDescriptions,
		descriptionsHowToSolve: AnomalyEntity.HowToSolveDescriptions,
		reasons: AnomalyEntity.TypeReasons,
		availableSystems: {},
		availableRoles: {},
		availableTypes: {}
	};

	ngOnInit() {
		this.anomalies_load();
	}

	public anomalies_load() {
		console.log('anomalies_load');
		this.anomalies.loading = true;
		this.apiQAR.retrieveAnomalies().then(r => {
			this.anomalies.chunker = new Chunker([]);
			console.log('retrieved', r);
			this.anomalies.loading = false;
			this.anomalies.availableSystems = {};
			this.anomalies.availableRoles = {};
			this.anomalies.availableTypes = {};
			const noDuplicates = {};
			const withDuplicates = {};
			for (const row of r) {
				this.anomalies.availableSystems[row.SystemId] = row.SystemName;

				if (row.RoleName) {
					this.anomalies.availableRoles[row.RoleName] = row.RoleName;
				}

				const type = AnomalyEntity.TypeReasons[row.Type];

				// keep the first one
				if (!withDuplicates[row.Id]) {
					withDuplicates[row.Id] = [];
				}
				withDuplicates[row.Id].push(row);
				this.anomalies.availableTypes[type] = type;
			}
			console.log('withDuplicates', withDuplicates);
			this.anomalies.withDuplicates = withDuplicates;
			this.anomalies.chunker = new Chunker(r);
		}, e => {
			this.anomalies.loading = false;
			alert('sorry, something went wrong, please try to refresh the table again');
		}).catch(e => {
			this.anomalies.loading = false;
			alert('sorry, something went wrong, please try to refresh the table again');
		});
	}

	getSystemIdFromRow(f: AnomalyResult) {
		return parseInt(f.SystemId, 0);
	}

	getFirstNameFromRow(f: AnomalyResult) {
		if (f.FirstName) {
			return f.FirstName;
		}
		return 'notfound';
	}

	getLastNameFromRow(f: AnomalyResult) {
		if (f.LastName) {
			return f.LastName;
		}
		return 'notfound';
	}

	getTypeDescriptionFromRow(f: AnomalyResult) {
		return AnomalyEntity.TypeDescriptions[f.Type];
	}

	getTypeFromRow(f: AnomalyResult) {
		return AnomalyEntity.TypeReasons[f.Type];
	}

	getLocalAliasFromRow(f: AnomalyResult) {
		return f.LocalAlias;
	}

	getRoleIdFromRow(f: AnomalyResult) {
		if (f.SystemRoleId) {
			return parseInt(f.SystemRoleId, 0);
		}
		return -1;
	}


	onSystemRowClick(report) {
		this.anomalies.SystemBatchRowIdSelected = report.SystemBatchRowId;
		this.anomalies.selected = report;
	}

	public comments_save(Id, Comments) {
		this.apiQAR.updateAnomaliesComments(Id, Comments).then(r => {
			this.anomalies_load();
			this.alert('Record has been saved successfully.', '');
		}, e => {
			console.log(e);
			this.alert('Sorry, could not saved at this moment');
		});

		return;
	}

	public alert(text, title = 'Warning') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public modalAlert = {
		display: false,
		title: '',
		text: '',
		cb: (yesorno) => {
		}
	};
}
